define("Ames.DotDigitalTracker.DotDigtalTracker", [
  "LiveOrder.Model",
], function (LiveOrderModel) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent("Layout");
      var userProfile = container.getComponent("UserProfile");
      var environment = container.getComponent("Environment");
      var accountId = environment.getConfig("DotDigital.AccountId");
      var domain = environment.getConfig("DotDigital.Domain");
      var cartDelay = environment.getConfig("DotDigital.CartDelay") || 30;
      var programId = environment.getConfig("DotDigital.ProgramId"); // Default program ID
      var cartComponent = container.getComponent("Cart");
      var liveOrderInstance = LiveOrderModel.getInstance();
      var self = this;
      self.currencyCode = SC.ENVIRONMENT.currentCurrency.code || "USD"; // Default to USD if not set

      debugger

      if (layout) {
        layout.on(
          "afterShowContent",
          this.loadScript(userProfile, accountId, domain)
        );

        layout.on("afterShowContent", function () {
          self.sendCartData(
            cartComponent,
            accountId,
            false,
            cartDelay,
            userProfile,
            programId
          );
        });

        cartComponent.on("afterAddLine", function () {
          self.sendCartData(
            cartComponent,
            accountId,
            false,
            cartDelay,
            userProfile,
            programId
          );
        });
      }

      liveOrderInstance.cancelableOn(
        "before:LiveOrder.submit",
        function beforeLiveOrderSubmitDotDigitalHandler() {
          self.sendCartData(
            cartComponent,
            accountId,
            true,
            cartDelay,
            userProfile,
            programId
          );
        }
      );
    },

    loadScript: function loadScript(userProfile, accountId, domain) {
      if (window.dmPtTrackingLoaded) return;
      window.dmPtTrackingLoaded = true;

      (function (w, d, u, t, o, c) {
        w["dmtrackingobjectname"] = o;
        c = d.createElement(t);
        c.async = 1;
        c.src = "https://static.trackedweb.net/js/_dmptv4.js";
        t = d.getElementsByTagName(t)[0];
        t.parentNode.insertBefore(c, t);
        w[o] =
          w[o] ||
          function () {
            (w[o].q = w[o].q || []).push(arguments);
          };
      })(window, document, null, "script", "dmPt");

      window.dmPt("create", accountId, domain);
      window.dmPt("track");
    },

    generateUUID: function generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    sendCartData: function sendCartData(
      cartComponent,
      accountId,
      isCheckout,
      cartDelay,
      userProfile,
      programId
    ) {
      var self = this;
      cartComponent.getSummary().done(function (summary) {
        cartComponent.getLines().done(function (lines) {
          if (lines.length === 0) {
            localStorage.removeItem("dotDigitalCartId");
            return;
          }

          // somewhere in your tracker module, at top‐level:
          function getDotDigitalCartId() {
            var key = "dotDigitalCartId";
            // try localStorage (persists even if they close the tab)
            var cartId = localStorage.getItem(key);
            if (!cartId) {
              // generate a quick UUID (RFC4122 version 4)
              cartId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
                /[018]/g,
                (c) =>
                  (
                    c ^
                    (crypto.getRandomValues(new Uint8Array(1))[0] &
                      (15 >> (c / 4)))
                  ).toString(16)
              );
              localStorage.setItem(key, cartId);
            }
            return cartId;
          }
          // 1. Create the required cartData object
          var cartData = {
            programID: programId, // Use the program ID from environment config
            programId: programId, // Use the program ID from environment config
            cartDelay: 1,
            cartPhase: isCheckout ? "ORDER_COMPLETE" : "CART", // Use valid phases
            currency: self.currencyCode, // Use proper currency code
            subtotal: summary.subtotal || 0,
            shipping: summary.shippingcost || 0,
            modifieddate: new Date().toISOString(),
            discountAmount: summary.discounttotal || 0,
            taxAmount: summary.taxtotal || 0,
            grandTotal: summary.total || 0,
            cartUrl: SC.ENVIRONMENT.currentHostString + "/cart",
            lineItems: lines.map(function (line) {
              var item = line.item;
              var img = item.extras?.keyMapping_thumbnail?.url || "";

              return {
                sku: item.itemid,
                name: item.displayname,
                description: item.extras?.stockdescription || "",
                category: "",
                unitPrice: line.rate,
                salePrice: line.rate,
                quantity: line.quantity,
                totalPrice: line.amount,
                imageUrl: img,
                productUrl:
                  SC.ENVIRONMENT.currentHostString +
                  (item.extras?.urlcomponent || ""),
              };
            }),
          };

          // 2. Wrap in the required cartData field
          var insightPayload = {
            cartId: getDotDigitalCartId(), // Use the function to get cart ID
            cartData: cartData, // REQUIRED by DotDigital API
            modifieddate: new Date().toISOString(),
            programID: programId, // Use the program ID from environment config
            programId: programId, // Use the program ID from environment config
            subtotal: summary.subtotal || 0,
            cartDelay: 1,
            cartPhase: isCheckout ? "ORDER_COMPLETE" : "CART", // Use valid phases
            currency: self.currencyCode, // Use proper currency code
            shipping: summary.shippingcost || 0,
            modifieddate: new Date().toISOString(),
            discountAmount: summary.discounttotal || 0,
            taxAmount: summary.taxtotal || 0,
            grandTotal: summary.total || 0,
            cartUrl: SC.ENVIRONMENT.currentHostString + "/cart",
            lineItems: lines.map(function (line) {
              var item = line.item;
              var img = item.extras?.keyMapping_thumbnail?.url || "";

              return {
                sku: item.itemid,
                name: item.displayname,
                description: item.extras?.stockdescription || "",
                category: "",
                unitPrice: line.rate,
                salePrice: line.rate,
                quantity: line.quantity,
                totalPrice: line.amount,
                imageUrl: img,
                productUrl:
                  SC.ENVIRONMENT.currentHostString +
                  (item.extras?.urlcomponent || ""),
              };
            }),
          };

          // 3. Identify user if available
          userProfile.getUserProfile().then(function (profile) {
            if (profile.email) {
              window.dmPt("identify", { email: profile.email });
            }
            window.dmPt("cartInsight", insightPayload);
          });
        });
      });
    },
  };
});
